import { staticAssetApi } from '../../modules/servers/api'
//
// ### Upload asset
// POST localhost:5689/api/upload
// Authorization: Bearer {{auth_token}}
// Content-Type: multipart/form-data; boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW
//
// ------WebKitFormBoundary7MA4YWxkTrZu0gW
// Content-Disposition: form-data; name="type"
//
// images/players
// ------WebKitFormBoundary7MA4YWxkTrZu0gW
// Content-Disposition: form-data; name="name"
//
// 1234
// ------WebKitFormBoundary7MA4YWxkTrZu0gW
// Content-Disposition: form-data; name="file"; filename="player_avatar.jpg"
// Content-Type: image/jpeg
//
// < ./test-image.jpg
const endpoints = staticAssetApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: (body) => ({
        url: '/upload',
        method: 'POST',
        body
      })
    })
  })
})

export const { useUploadImageMutation } = endpoints
